import { createPortal } from 'react-dom';
import { useAuctionWheelFrogScene } from './useAuctionWheelFrogScene';
import './AuctionWheelFrogs.css';

export const AuctionWheelFrogs = ({
  isSpinning = false,
  spinDuration = 10,
  showElimination = false,
  showWinner = false,
}) => {
  const activeScene = useAuctionWheelFrogScene({
    isSpinning,
    spinDuration,
    showElimination,
    showWinner,
  });

  if (!activeScene) {
    return null;
  }

  return createPortal(
    <div
      key={activeScene.id}
      className={`auction-wheel-frog auction-wheel-frog--${activeScene.animation}`}
      aria-hidden="true"
      data-auction-wheel-frog-scene={activeScene.id}
    >
      <div className="auction-wheel-frog__art-window">
        <img
          className="auction-wheel-frog__art"
          src={activeScene.image}
          alt=""
          draggable="false"
        />
      </div>
    </div>,
    document.body,
  );
};
